<template>
  <!-- <main-header></main-header> -->
  <div class="container-fluid p-0">

    <!-- Hero section -->
    <section id="section-1">
      <video id="my-player" class="d-none d-md-block" width="100%" autoplay muted loop v-if="landingWidth > 768">
        <!-- <source :src="require('@/assets/video/MIMENTE-SONIDO-2.mp4')" type="video/mp4"> -->
        <source src="https://s3.amazonaws.com/sherpa.digital/sherpa_care/assets/MIMENTE-SONIDO.mp4" type="video/mp4">
      </video>
      <video id="my-player-mobile" class="d-sm-block d-md-none" width="100%" autoplay muted loop playsinline v-else>
        <!-- <source :src="require('@/assets/video/MIMENTE-VIDEO_VERTICAL.mp4')" type="video/mp4"> -->
        <source src="https://s3.amazonaws.com/sherpa.digital/sherpa_care/assets/MIMENTE-VIDEO_VERTICAL.mp4" type="video/mp4">
      </video>
      <div class="bottom-buttons-video">
        <div class="row">
          <div class="col-4"></div>
          <div class="col-4 text-center">
            <button
                class="btn mm-btn mm-btn-secondary"
                id="start-button"
                @click.prevent="goToReasons"
                v-if="isB2CRoute">Comenzar
            </button>
          </div>
          <div class="col-4 text-end">
            <button class="btn muted" :class="{ 'muted': videoSound, 'unmuted': !videoSound }" id="sound-button" @click.prevent="muteVideo"></button>
          </div>
        </div>
      </div>
    </section>
    <!-- Hero section ends -->

    <!-- Start section 2 -->
    <div class="w-100 mm-blue-card" id="section-2">
      <div class="container">
        <div class="row">
          <div class="col-sm-12 col-md-6 offset-md-6 text-end">
            <p class="section-2-title m-0">Terapia adecuada a tu mente</p>
          </div>
        </div>
        <div class="row align-items-end">
          <div class="col-sm-12 col-md-6">
            <p class="section-2-p-1 m-0">Conoce a tu psicólogo ideal para recorrer la vida con mayor <span class="yellow-span">auto-conocimiento.</span></p>
            <br>
            <p class="section-2-p-2 m-0">MiMente es una clínica digital de terapia en línea que te conecta con psicólogos altamente preparados y adecuados para tus necesidades particulares.</p>
          </div>
          <div class="col-sm-12 col-md-6">
            <div class="section-2-button">
              <a href="#section-9" class="btn mm-btn mm-btn-secondary">Quiero conocer MiMente</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- End section 2 -->

    <!-- Start section 3 -->
    <div class="container-fluid" id="section-3">
      <div class="container">
        <div class="row">
          <div class="col-12 text-center">
            <p class="section-3-title">La terapia transforma</p>
            <p class="section-3-text-1 mx-md-auto">Todos tenemos la oportunidad de alcanzar lo que deseamos<br class="d-none d-sm-block">a nivel personal. Para lograr esto, requerimos de ayuda en el camino.</p>
            <p class="section-3-text-2">Conoce los retos que nos enfrentamos hoy:</p>
          </div>
        </div>
        <div class="row row-yellow-card-custom-mt gx-md-5"> <!-- mb-md-5 -->
          <div class="col-12 col-md-4 right-items">
            <div class="yellow-card border-top-bottom-left-radius">
              <span class="yellow-card-big-letter">#1</span>
              <p class="yellow-card-text-1">México es #Nº1 a nivel mundial en estrés laboral.</p>
              <p class="yellow-card-text-2">(75% de los trabajadores reportan alto estrés)</p>
            </div>
          </div>
          <div class="col-12 col-md-4">
            <div class="yellow-card border-top-bottom-right-radius">
              <span class="yellow-card-big-letter">29%</span>
              <p class="yellow-card-text-1">29% de los mexicanos adultos han padecido algún trastorno mental.</p>
              <p class="yellow-card-text-2">Sólo 1⁄5 recibe tratamiento.</p>
            </div>
          </div>
          <div class="col-12 col-md-4 right-items">
            <div class="yellow-card border-top-bottom-left-radius">
              <span class="yellow-card-big-letter">15%</span>
              <p class="yellow-card-text-1">15% de los mexicanos luchan contra la depresión (previo al COVID-19).</p>
              <p class="yellow-card-text-2">OMS, National Survey of Psychiatric Epidemiology</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- End section 3 -->

    <!-- Start section 4 -->
    <div class="container" id="section-4">
      <div class="row">
        <div class="col-12 text-center">
          <p class="section-4-title">¿Cómo funciona?</p>
        </div>
      </div>
      <div class="row d-flex justify-content-evenly m-w-1000 squares-info">
        <div class="section-4-card-blue-container">
          <div class="section-4-card-blue section-4-first-blue-card">
            <div>1</div>
            <p>Contesta un breve cuestionario.</p>
          </div>
        </div>
        <div class="section-4-card-blue-container">
          <div class="section-4-card-blue section-4-second-blue-card">
            <div>2</div>
            <p>Te presentamos una variedad de psicólogos que se alinean a tus necesidades.</p>
          </div>
        </div>
        <div class="section-4-card-blue-container">
          <div class="section-4-card-blue section-4-third-blue-card">
            <div>3</div>
            <p>¡Elige al psicólogo con el que más cómodo te sientas y agenda tu cita!</p>
          </div>
        </div>
      </div>
      <!-- <div class="row mb-md-5">
        <div class="col-12">
          <div class="section-4-card-container"></div>
        </div>
      </div> -->
      <div class="row d-flex justify-content-center">
        <div class="col-12 col-md-7 text-center">
          <br>
          <p class="text-blue legend">Si decides cambiar de especialista, no hay problema, simplemente agenda cita con otro de nuestros psicólogos.</p>
        </div>
      </div>
    </div>
    <!-- End section 4 -->

    <!-- start section 5 -->
    <div class="col-12">
      <section id="section-5">
        <div class="bg-blue-community pt-0 pb-0">

          <p class="section-5-title text-center">Nuestra comunidad</p>

          <div class="content-section">
            <!-- start flex section -->
            <div class="flex-container d-sm-block d-md-none">

              <div class="row mb-4">
                <div class="col-6">
                  <img class="section-5-vertical-image" src="@/assets/landingpage/alfonso.jpeg" alt="" style="height: 260px;">
                </div>
                <div class="col-6">
                  <p class="section-5-p-white mt-1 section-5-p-yellow">
                    <span class="section-5-p-white-span-1">Como emprendedores, debemos romper el estigma de la terapia; es nuestro aliado más valioso en esta montaña rusa, una herramienta clave para navegar con claridad y resiliencia en el viaje del emprendimiento.</span>
                    <span class="section-5-p-white-span-2">ALFONSO</span>
                  </p>
                </div>
              </div>

              <div class="row mb-4">
                <div class="col-6">
                  <p class="section-5-p-white mt-1 section-5-p-yellow">
                    <span class="section-5-p-white-span-1">Mimente es mi oportunidad de tomar mi consulta psicológica desde mi lugar seguro para poder avanzar en mi proceso de sanción personal.</span>
                    <span class="section-5-p-white-span-2">CINTHYA</span>
                  </p>
                </div>
                <div class="col-6">
                  <img class="section-5-vertical-image" src="@/assets/landingpage/comentarios2.jpeg" alt="">
                </div>
              </div>

              <div class="row mb-4">
                <div class="col-6">
                  <img src="@/assets/landingpage/comentarios1.jpeg" alt="" class="section-5-vertical-image">
                </div>
                <div class="col-6">
                  <p class="section-5-p-white mt-1">
                    <span class="section-5-p-white-span-1">Mimente es muy práctico y fácil de usar con una gran variedad de psicólogos para apoyar en cualquier tema.</span>
                    <span class="section-5-p-white-span-2">JORGE</span>
                  </p>
                </div>
              </div>

              <div class="row mb-4">
                <div class="col-6">
                  <p class="section-5-p-white mt-1 section-5-p-yellow">
                    <span class="section-5-p-white-span-1">Una empresa que invierte en la salud mental de su gente no solo humaniza el lugar de trabajo, sino que también potencializa la productividad y la innovación.</span>
                    <span class="section-5-p-white-span-2">HÉCTOR</span>
                  </p>
                </div>
                <div class="col-6">
                  <img class="section-5-vertical-image" src="@/assets/landingpage/hector.jpg" alt="">
                </div>
              </div>

              <div class="row mb-4">
                <div class="col-6">
                  <img class="section-5-vertical-image" src="@/assets/landingpage/comentarios3.jpeg" alt="">
                </div>
                <div class="col-6">
                  <p class="section-5-p-white mt-1 section-5-p-yellow">
                    <span class="section-5-p-white-span-1">"Mimente es muy práctico porque todo está en un mismo lugar."</span>
                    <span class="section-5-p-white-span-2">ISABELLA</span>
                  </p>
                </div>
              </div>

              <div class="row mb-4">
                <div class="col-6">
                  <p class="section-5-p-white mt-1">
                    <span class="section-5-p-white-span-1">La terapia le sirve a todos. En los momentos buenos y en los malos.</span>
                    <span class="section-5-p-white-span-2">BEBA</span>
                  </p>
                </div>
                <div class="col-6">
                  <img src="@/assets/landingpage/comentarios5.png" alt="" class="section-5-vertical-image">
                </div>
              </div>

            </div>
            <!-- end flex section -->

            <!-- star grid section -->
            <div class="d-none d-md-grid">
              <div class="row">
                <div class="col-3">
                  <div class="section-5-big-image">
                    <img src="@/assets/landingpage/alfonso.jpeg">
                  </div>
                  <div class="section-5-big-comment bg-white">
                    <div>
                      <p class="comment" style="margin-bottom: 2.5rem;">Mimente es mi oportunidad de tomar mi consulta psicológica desde mi lugar seguro para poder avanzar en mi proceso de sanción personal.</p>
                      <p class="name">Cinthya</p>
                    </div>
                  </div>
                  <div class="section-5-small-image">
                    <img src="@/assets/landingpage/comentarios2.jpeg" style="object-position: 0px 70%;">
                  </div>
                </div>
                <div class="col-3">
                  <div class="section-5-big-comment bg-white">
                    <div>
                      <p class="comment" style="margin-bottom: 2.3rem;">Como emprendedores, debemos romper el estigma de la terapia; es nuestro aliado más valioso en esta montaña rusa, una herramienta clave para navegar con claridad y resiliencia en el viaje del emprendimiento.</p>
                      <p class="name">Alfonso</p>
                    </div>
                  </div>
                  <div class="section-5-medium-comment bg-yellow">
                    <p class="comment mb-5">Mimente es muy práctico y fácil de usar con una gran variedad de psicólogos para apoyar en cualquier tema.</p>
                    <p class="name">Jorge</p>
                  </div>
                  <div class="section-5-medium-image">
                    <img src="@/assets/landingpage/jorge800.png" alt="">
                  </div>
                </div>
                <div class="col-3">
                  <div class="section-5-big-comment bg-white">
                    <div>
                      <p class="comment" style="margin-bottom: 2.2rem;">Una empresa que invierte en la salud mental de su gente no solo humaniza el lugar de trabajo, sino que también potencializa la productividad y la innovación.</p>
                      <p class="name">Héctor</p>
                    </div>
                  </div>
                  <div class="section-5-big-image">
                    <img src="@/assets/landingpage/comentarios3.jpeg" alt="">
                  </div>
                  <div class="section-5-small-comment bg-yellow">
                    <p class="comment">"Mimente es muy práctico porque todo está en un mismo lugar."</p>
                    <p class="name">Isabella</p>
                  </div>
                </div>
                <div class="col-3">
                  <div class="section-5-big-image" style="padding-top: 93%">
                    <img src="@/assets/landingpage/hector.jpg" alt="">
                  </div>
                  <div class="section-5-small-comment bg-yellow">
                    <p class="comment">La terapia le sirve a todos. En los momentos buenos y en los malos.</p>
                    <p class="name">Beba</p>
                  </div>
                  <div class="section-5-medium-image" style="padding-top: 100%;">
                    <img src="@/assets/landingpage/comentarios5.png" alt="">
                  </div>
                </div>
              </div>
            </div>
            <!-- end grid section -->
          </div>

        </div>
      </section>
    </div>
    <!-- end section 5 -->

    <!-- start section 6 -->
    <div class="container" id="section-6">
      <div class="row">
        <div class="col-12">
          <p class="section-6-title">Nuestro compromiso</p>
        </div>
      </div>
      <div class="row mb-md-3">
        <div class="col-12 col-md-6 mb-sm-2">
          <div class="card-image-container">
            <div class="section-6-grid" :style="{ 'grid-template-rows': toggleSections.section_6_more_1 ? 'auto 1fr' : '1fr' }">
              <p class="align-self-end section-6-card-title">CALIDAD</p>
              <!--              v-if="toggleSections.section_6_more_1"-->
              <p class="section-6-card-text" id="section-6_text-1">El psicólogo que te recomienda tu amigo o familiar no necesariamente es el mejor para ti. Nosotros buscamos al psicólogo clínico mejor preparado para atenderte.</p>
            </div>
            <!--            <span id="section_6_more_1" @click="openCard"> {{ toggleSections.section_6_more_1 ? '-' : '+' }} </span>-->
          </div>
        </div>
        <div class="col-12 col-md-6 mb-sm-2">
          <div class="card-image-container">
            <div class="section-6-grid" :style="{ 'grid-template-rows': toggleSections.section_6_more_2 ? 'auto 1fr' : '1fr' }">
              <p class="align-self-end section-6-card-title">CONFIDENCIALIDAD</p>
              <!--              v-if="toggleSections.section_6_more_2"-->
              <p class="section-6-card-text">Medios como Zoom no aseguran la confidencialidad médica, mientras que en MiMente nos aseguramos de proteger tu privacidad. Estamos alineados con los estándares HIPAA de seguridad a la información médica de los Estados Unidos. Todo queda entre tu psicólogo y tú.</p>
            </div>
            <!--            <span id="section_6_more_2" @click="openCard"> {{ toggleSections.section_6_more_2 ? '-' : '+' }} </span>-->
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-md-6 mb-sm-2">
          <div class="card-image-container">
            <div class="section-6-grid" :style="{ 'grid-template-rows': toggleSections.section_6_more_3 ? 'auto 1fr' : '1fr' }">
              <p class="align-self-end section-6-card-title">CONFIANZA</p>
              <!--              v-if="toggleSections.section_6_more_3"-->
              <p class="section-6-card-text">Nuestras sesiones son espacios de total confianza, donde puedes expresarte genuinamente, libre de juicios y presiones. Es un momento para ti, un espacio de reflexión y desarrollo.</p>
            </div>
            <!--            <span id="section_6_more_3" @click="openCard"> {{ toggleSections.section_6_more_3 ? '-' : '+' }} </span>-->
          </div>
        </div>
        <div class="col-12 col-md-6 mb-sm-2">
          <div class="card-image-container">
            <div class="section-6-grid" :style="{ 'grid-template-rows': toggleSections.section_6_more_4 ? 'auto 1fr' : '1fr' }">
              <p class="align-self-end section-6-card-title">COMODIDAD</p>
              <!--              v-if="toggleSections.section_6_more_4"-->
              <p class="section-6-card-text">Puedes tomar tus sesiones terapéuticas desde el confort y seguridad de tu casa. Toda la atención que recibas será completamente en línea y confidencial.</p>
            </div>
            <!--            <span id="section_6_more_4" @click="openCard"> {{ toggleSections.section_6_more_4 ? '-' : '+' }} </span>-->
          </div>
        </div>
      </div>
    </div>
    <!-- end section 6 -->


    <!-- start section 7 -->
    <div class="container" id="section-7">
      <div class="row">
        <div class="col-12 col-lg-5 d-none d-lg-block">
          <img class="section-7-img" src="@/assets/landingpage/Manos1.png" alt="">
        </div>
        <div class="col-12 col-lg-7">
          <p class="section-7-title">Estás en las mejores manos</p>
          <p class="section-7-text">Todos nuestros especialistas cuentan con:</p>
          <p class="section-7-list-item">
            MÍNIMO 3 AÑOS DE EXPERIENCIA DANDO TERAPIA
          </p>
          <p class="section-7-list-item">
            ESTUDIOS A NIVEL MAESTRÍA
          </p>
          <p class="section-7-list-item">
            EVALUADOS CON ENTREVISTAS Y ROL PLAY
          </p>
          <p class="section-7-list-item">
            VALORACIÓN DE SU INTELIGENCIA EMOCIONAL Y EMPÁTICA
          </p>
        </div>
      </div>
    </div>
    <!-- end section 7 -->

    <!-- start section 8 -->
    <div class="container" id="section-8">
      <div class="section-8-card-blue-container">
        <div class="row">
          <div class="col-12 col-lg-5 d-flex align-items-center position-relative">
            <img class="section-8-app-image" src="@/assets/landingpage/bienestar.png" alt="">
          </div>
          <div class="col-12 col-lg-7 pt-10">
            <div class="row">
              <div class="col-12">
                <p class="section-8-title">Lleva el bienestar a todo lugar con <span>Sherpa</span></p>
                <p class="section-8-text">Como parte de la comunidad de MiMente, tendrás acceso a nuestra aplicación de Sherpa Bienestar para acompañarte en tu viaje hacia el bienestar emocional y mental.</p>
                <p class="section-8-text section-8-text-yellow">En el app encontrarás herramientas efectivas como:</p>
              </div>
              <div class="col-12">
                <div class="badges-container">
                  <span>Meditaciones guiadas.</span>
                  <span>Diario digital para reflexionar diariamente.</span>
                  <span>Técnicas para mejorar la calidad de tu sueño.</span>
                  <span>Check-in de emociones.</span>
                  <span>Visualización de tu vida emocional.</span>
                  <span>¡Y mucho más!</span>
                  <a href="#">
                    <img src="@/assets/images/landingv2/apple.svg" alt="Sherpa Bienestar">
                  </a>

                  <a href="#">
                    <img src="@/assets/images/landingv2/android.svg" alt="Sherpa Bienestar">
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
    <!-- end section 8 -->

    <!-- start section 9 -->
    <div class="col-12" id="section-9">
      <div class="container">
        <div class="row">
          <div class="col-12 col-md-5">
            <p class="section-9-title">Te escuchamos</p>
            <p class="section-9-text m-0">¡Platica con nosotros!</p>
            <p class="section-9-text">Si tienes cualquier duda, nuestros expertos están disponibles.</p>
          </div>
          <div class="col-12 col-md-7">
            <div class="row">
              <div class="col-12 col-md-6">
                <div class="form-group has-validation" :class="{'has-error' : name_has_error}">
                  <input type="text" class="form-control" placeholder="* Nombre" v-model="comments.name">
                </div>
              </div>
              <div class="col-12 col-md-6">
                <div class="form-group has-validation">
                  <input type="text" class="form-control" placeholder="Apellido" v-model="comments.last_name">
                </div>
              </div>
              <div class="col-12">
                <div class="form-group has-validation" :class="{'has-error' : email_has_error}">
                  <input type="text" class="form-control" placeholder="* Email" v-model="comments.email">
                </div>
              </div>
              <div class="col-12">
                <div class="form-group has-validation" :class="{'has-error' : comments_has_error}">
                  <textarea name="" id="" cols="30" rows="4" class="form-control" placeholder="* Mensaje" v-model="comments.comments"></textarea>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 d-flex justify-content-end">
            <button class="btn btn-primary" id="section-9-send-button" @click="sendComments">Enviar</button>
          </div>
        </div>
      </div>
    </div>
    <!-- end section 9 -->

    <div class="footer-parent p-4">

      <!-- Big logo section -->
      <div class="col-12">
        <section id="big-logo-section">
          <div class="container-xxl g-3">
            <div class="row">
              <div class="col-12 text-center">
                <img src="@/assets/images/landingv2/mimente.svg" alt="MiMente">
              </div>
            </div>
          </div>
        </section>
      </div>
      <!-- Big logo section ends -->

      <main-footer
          class="personal-footer"
          :facebookIcon='require("@/assets/images/landingv2/facebook-icon-blue.svg")'
          :instagramIcon='require("@/assets/images/landingv2/instagram-icon-blue.svg")'
          :tikTokIcon='require("@/assets/images/landingv2/tiktok-icon-blue.svg")'
      ></main-footer>

    </div>


  </div>
</template>

<script>
import {useI18n} from 'vue-i18n'
import {computed, defineAsyncComponent, onMounted, onUnmounted, ref} from 'vue';
import MainFooter from '@/components/FooterV2.vue'
import {useRoute, useRouter} from 'vue-router';
import {useStore} from 'vuex';
import AOS from 'aos';
import 'aos/dist/aos.css';
import psychologistService from '@/services/psychologistService';
import swalUtil from '@/utils/sweetalertUtil'

export default {
  components: {
    MainFooter,
    MainHeader: defineAsyncComponent(() => import('@/components/HeaderV2.vue')),
  },
  setup() {
    const {t} = useI18n();
    const router = useRouter();
    const route = useRoute();
    const store = useStore();
    const toggleSections = ref({
      'section_6_more_1': false,
      'section_6_more_2': false,
      'section_6_more_3': false,
      'section_6_more_4': false
    });

    const comments = ref({});
    const name_has_error = ref(false);
    const email_has_error = ref(false);
    const comments_has_error = ref(false);
    const videoSound = ref(true);
    const landingWidth = ref(null);

    const loggedUser = computed(() => store.getters['auth/getLoggedUser'])
    let listener = null;

    const muteVideo = () => {
      setTimeout(() => {
        if (landingWidth.value > 768)
          document.getElementById("my-player").muted = !videoSound.value;
        else
          document.getElementById("my-player-mobile").muted = !videoSound.value;
        videoSound.value = !videoSound.value;
      }, 100)
    }

    const sendComments = async () => {

      name_has_error.value = false
      email_has_error.value = false
      comments_has_error.value = false

      if (comments.value?.name !== undefined && comments.value?.email !== undefined && comments.value?.comments !== undefined) {

        const {data} = await psychologistService.saveClientComments(comments.value);
        const {result} = data;
        if (!result.error) {

          comments.value = {}

          await swalUtil.fire({
            icon: "success",
            title: 'Información enviada',
            text: 'Gracias por enviarnos tus comentarios.',
            customClass: 'sherpa-alert',
            backdrop: 'rgba(255,255,255,0.8)',
            allowOutsideClick: false,
            allowEscapeKey: false,
          })
        } else {
          await swalUtil.fire({
            icon: "success",
            title: 'Tenemos problemas en procesar tu información',
            text: 'Favor de intentar más tarde.',
            customClass: 'sherpa-alert',
            backdrop: 'rgba(255,255,255,0.8)',
            allowOutsideClick: false,
            allowEscapeKey: false,
          })
        }

      } else {

        if (comments.value.name == undefined) {
          name_has_error.value = true
        }

        if (comments.value.email == undefined) {
          email_has_error.value = true
        }

        if (comments.value.comments == undefined) {
          comments_has_error.value = true
        }

      }

    }

    const goToReasons = () => router.push({name: 'reasons-page'})

    const goToLogin = () => {
      const loginModal = new bootstrap.Modal(document.getElementById('loginModal'))
      loginModal.show()
    }

    const openRegisterB2b = () => {
      const b2bRegisterModal = new bootstrap.Modal(document.querySelector('#b2bRegisterModal'))
      b2bRegisterModal.show()
      toggleSidenav()
    }

    const logout = () => {
      store.commit('auth/logout')
      router.push({name: 'login-page'})
    }

    const openCard = ({target}) => {
      toggleSections.value[target.id] = !toggleSections.value[target.id];
    }

    const isB2CRoute = computed(() => route.name == 'personal-lading-page');

    onMounted(() => {
      AOS.init({
        duration: 2000
      });

      if (route.name == 'landing-page-family') {
        store.commit('auth/setIsFamilyRoute', true);
        // openRegisterB2b();
      } else {
        store.commit('auth/setIsFamilyRoute', false);
      }

      store.commit('setGeneralIsLoading', false);
      landingWidth.value = document.body.offsetWidth;
      listener = window.addEventListener("resize", () => {
        landingWidth.value = document.body.offsetWidth;
      });
    })

    onUnmounted(() => {
      document.querySelector('body').removeAttribute('data-aos-easing')
      window.removeEventListener("resize", listener);
    })

    return {
      router,
      loggedUser,
      toggleSections,
      videoSound,
      comments,
      name_has_error,
      email_has_error,
      comments_has_error,
      landingWidth,
      isB2CRoute,
      t,
      goToReasons,
      openCard,
      goToLogin,
      logout,
      openRegisterB2b,
      muteVideo,
      sendComments
    }
  }
}

</script>

<style scoped>

.section-5-big-image {
  height: 0;
  overflow: hidden;
  padding-top: 100%;
  box-sizing: border-box;
  position: relative;
  margin-bottom: 25px;
}

.section-5-big-image img {
  width: 100%;
  vertical-align: top;
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  border-radius: 25px;
  object-fit: cover;
}

/************************************************/

.section-5-big-comment {
  padding: 15px;
  border-radius: 25px;
  margin-bottom: 25px;
}

/*.section-5-big-comment div {*/
/*  height: 240px;*/
/*}*/

.section-5-big-comment .comment {
  font-family: 'Basier Circle';
  font-size: 19px;
  color: #26384c;
  font-weight: 500;
  margin-bottom: 15px;
}

.section-5-big-comment .name {
  color: white;
  background: #26384c;
  display: inline-block;
  margin: 0;
  border-radius: 100px;
  font-size: 16px;
  padding: 3px 13px;
  text-transform: uppercase;
}

/************************************************/

.section-5-small-image {
  height: 0;
  overflow: hidden;
  padding-top: 80%;
  box-sizing: border-box;
  position: relative;
}

.section-5-small-image img {
  width: 100%;
  vertical-align: top;
  position: absolute;
  top: 0;
  left: 0;
  height: 60%;
  border-radius: 25px;
  object-fit: cover;
}

/************************************************/

.section-5-small-comment {
  padding: 15px;
  border-radius: 25px;
  margin-bottom: 25px;
}

.section-5-small-comment .comment {
  font-family: 'Basier Circle';
  font-size: 19px;
  color: #26384c;
  font-weight: 500;
  margin-bottom: 15px;
}

.section-5-small-comment .name {
  color: white;
  background: #26384c;
  display: inline-block;
  margin: 0;
  border-radius: 100px;
  font-size: 16px;
  padding: 3px 13px;
  text-transform: uppercase;
}

/************************************************/

.section-5-medium-comment {
  padding: 15px;
  border-radius: 25px;
  margin-bottom: 25px;
}

.section-5-medium-comment .comment {
  font-family: 'Basier Circle';
  font-size: 19px;
  color: #26384c;
  font-weight: 500;
  margin-bottom: 15px;
}

.section-5-medium-comment .name {
  color: white;
  background: #26384c;
  display: inline-block;
  margin: 0;
  border-radius: 100px;
  font-size: 16px;
  padding: 3px 13px;
  text-transform: uppercase;
}

/************************************************/

.section-5-medium-image {
  height: 0;
  overflow: hidden;
  padding-top: 80%;
  box-sizing: border-box;
  position: relative;
}

.section-5-medium-image img {
  width: 100%;
  vertical-align: top;
  position: absolute;
  top: 0;
  left: 0;
  height: 80%;
  border-radius: 25px;
  object-fit: cover;
}


.bg-yellow {
  background: var(--mm-secondary);
}


.has-validation.has-error input, .has-validation.has-error textarea {
  border: 1.5px solid red !important;
}

/* section1 */
#section-1 {
  width: 100%;
  display: grid;
  height: auto;
  position: relative;
}

.bottom-buttons-video {
  margin-top: -5%;
  z-index: 9;
}

/* section2 */
#section-2 {
  color: white;
  padding-top: 65px;
  padding-bottom: 65px;
}

.landing-container {
  padding: 40px 100px 120px;
}

.mm-blue-card {
  background-color: var(--mm-primary);
}

.section-2-grid-rows {
  color: white;
  display: grid;
  grid-template-rows: repeat(2, 1fr);
  height: 100%;
}

.section-2-title {
  font-size: 63px;
  text-align: right;
  font-weight: 500;
  font-family: 'Basier Circle';
  line-height: 1;
  align-items: end;
}

.section-2-button {
  display: flex;
  justify-content: end;
  flex-wrap: wrap;
  align-items: end;
}

.section-2-button button, .section-2-button a {
  border-radius: 36px !important;
  padding: 17px 30px;
  font-family: 'Basier Circle';
  font-size: 20px;
  font-weight: 500;
}

.left-section {
  padding-top: 35%;
}

.yellow-span {
  font-family: 'MANIC';
  color: #FFE19B;
}

.section-2-p-1 {
  font-weight: 500;
  font-size: 26px;
}

.section-2-p-2 {
  font-size: 21px;
}

.section-2-left-container {
  display: flex;
  align-items: end;
}

/* section 2 end */

/* section 3 start */
#section-3 {
  color: #567394;
  font-family: 'Basier Circle';
  padding-top: 65px;
  padding-bottom: 65px;
}

.section-3-title {
  font-size: 56px;
  font-weight: 500;
}

.section-3-text-1 {
  font-size: 21px;
  /*max-width: 60%;*/
}

.section-3-text-2 {
  font-size: 25px;
  font-weight: 500;
}

.row-yellow-card-custom-mt {
  margin-top: 6rem !important;
}

.yellow-card {
  background-color: #FFE8AE;
  border-radius: 60px;
  position: relative;
  text-align: center;
  padding: 18% 10% 2%;
  height: 100%;
}

.yellow-card-big-letter {
  position: absolute;
  top: 0;
  left: 50%;
  font-size: 120px;
  transform: translate(-50%, -50%);
}

.yellow-card-text-1 {
  font-size: 21px;
}

.yellow-card-text-2 {
  font-size: 21px;
}

/* section 3 end */

/* section 4 start */
#section-4 {
  color: white;
  padding-bottom: 70px;
  padding-bottom: 30px;
}

#section-4 .squares-info {
  margin: 40px 0px;
}

.section-4-title {
  font-size: 60px;
  font-weight: 500;
  font-family: 'Basier Circle';
  color: #567394;
}

.section-4-card-blue {
  background-color: #567394;
  border-radius: 42px;
  text-align: center;
  height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}


.section-4-first-blue-card::before {
  content: url('@/assets/landingpage/resorte1.svg');
  display: block;
  z-index: 2;
  position: absolute;
  width: 50%;
  bottom: 10%;
  left: 0;
  transform: translate(-50%, 0px);
}

.section-4-second-blue-card::after {
  content: url('@/assets/landingpage/puntos_azules.svg');
  display: block;
  z-index: 2;
  position: absolute;
  width: 20%;
  bottom: 40%;
  right: 0;
  transform: translate(140%, -12px);
}

.section-4-second-blue-card::before {
  content: url('@/assets/landingpage/puntos_azules.svg');
  display: block;
  z-index: 2;
  position: absolute;
  width: 20%;
  bottom: 40%;
  left: 0;
  transform: translate(-140%, -12px);
}

.section-4-third-blue-card::before {
  content: url('@/assets/landingpage/resorte2.svg');
  display: block;
  z-index: 2;
  position: absolute;
  width: 32%;
  top: 0;
  right: 0;
  transform: translate(50%, -10%);
}

.section-4-card-blue div {
  color: #567394 !important;
  font-family: 'MANIC';
  position: absolute;
  top: 0;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 80px;
  height: 80px;
  background-color: #FFE8AE;
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 60px;
}

.section-4-card-blue p {
  font-size: 21px;
  margin: 0 35px;
}

.text-blue {
  color: #567394;
}

.text-blue.legend {
  font-size: 21px;
}

.section-4-card-container {
  background-image: url('@/assets/landingpage/cuadrosmimente.png');
  background-position: center;
  background-repeat: no-repeat;
  min-height: 425px;
}

.section-4-card-blue-container {
  width: 280px !important;
  display: inline-block;
  padding: 0;
}

/* section 4 end */

/* setcion 5 start */
#section-5 {
  background: url("@/assets/landingpage/bga.png") center top no-repeat, url("@/assets/landingpage/bga-bottom.png") center bottom no-repeat;
  /* margin-top: 140px; */
  background-size: 100% 300px;
  padding-top: 140px;
  padding-bottom: 180px;
}

#section-5 .bg-blue-community {
  background-color: #26374C;
}

#section-5 .content-section {
  max-width: 1390px;
  width: 100%;
  margin: 0 auto;
}

.section-5-title {
  font-size: 60px;
  font-weight: 500;
  font-family: 'Basier Circle';
  color: white;
  margin-bottom: 40px;
}

.section-5-main-grid {
  display: grid;
  height: 100%;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 1fr;
  font-size: 17px;
  color: white;
  gap: 15px;
}

.section-2-columns-photo-left {
  display: grid;
  grid-template-columns: 300px 1fr;
  grid-template-rows: 1fr;
  grid-gap: 15px;
  height: 300px;
}

.section-2-columns-photo-right {
  display: grid;
  grid-template-columns: 1fr 300px;
  grid-template-rows: 1fr;
  grid-gap: 15px;
  height: 300px;
}

.section-5-sub-grid-2 {
  display: grid;
  grid-template-rows: 1fr 1fr;
  grid-template-columns: 1fr 40%;
  gap: 15px;
}

.section-5-grid-1-column-2-rows {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr 1fr;
  grid-gap: 15px;
  height: 300px;
}

.square-grid-photo {
  width: 300px;
  height: 300px;
}


/*.section-5-sub-grid-pos-1 .section-5-subgrid-item:nth-child(1) {*/
/*  grid-column: 1;*/
/*  grid-row: 1;*/
/*}*/

/*.section-5-sub-grid-pos-1 .section-5-subgrid-item:nth-child(2) {*/
/*  grid-column: 2;*/
/*  grid-row: 1;*/
/*}*/

/*.section-5-sub-grid-pos-1 .section-5-subgrid-item:nth-child(3) {*/
/*  grid-column: 2;*/
/*  grid-row: 2;*/
/*}*/

/*.section-5-sub-grid-pos-2 .section-5-subgrid-item:nth-child(1) {*/
/*  grid-column: 1;*/
/*  grid-row: 1;*/
/*}*/

/*.section-5-sub-grid-pos-2 .section-5-subgrid-item:nth-child(2) {*/
/*  grid-column: 2;*/
/*  grid-row: 1 / span 2;*/
/*}*/

/*.section-5-sub-grid-pos-2 .section-5-subgrid-item:nth-child(3) {*/
/*  grid-column: 1;*/
/*  grid-row: 2;*/
/*}*/

/*.section-5-sub-grid-pos-3 .section-5-subgrid-item:nth-child(1) {*/
/*  grid-column: 1;*/
/*  grid-row: 1;*/
/*}*/

/*.section-5-sub-grid-pos-3 .section-5-subgrid-item:nth-child(2) {*/
/*  grid-column: 2;*/
/*  grid-row: 1 / span 2;*/
/*}*/

/*.section-5-sub-grid-pos-3 .section-5-subgrid-item:nth-child(3) {*/
/*  grid-column: 1;*/
/*  grid-row: 2;*/
/*}*/

/*.section-5-sub-grid-pos-4 .section-5-subgrid-item:nth-child(1) {*/
/*  grid-column: 1;*/
/*  grid-row: 1 / span 2;*/
/*}*/

/*.section-5-sub-grid-pos-4 .section-5-subgrid-item:nth-child(2) {*/
/*  grid-column: 2;*/
/*  grid-row: 1;*/
/*}*/

/*.section-5-sub-grid-pos-4 .section-5-subgrid-item:nth-child(3) {*/
/*  grid-column: 2;*/
/*  grid-row: 2;*/
/*}*/

.section-5-vertical-image {
  height: 100%;
  max-height: 300px;
  width: 100%;
  border-radius: 20px;
  object-fit: cover;
}

.section-5-horizontal-image {
  height: 142.5px;
  width: 100%;
  max-height: 500px;
  object-fit: cover;
  border-radius: 20px;
  object-position: 0px 55%;
}

.section-5-p-white {
  background-color: #FAF6EE;
  color: #26374C;
  border-radius: 20px;
  padding: 10px;
  margin: 0px;
  height: 142.5px;
  font-family: 'Basier Circle';
  font-size: 16px;
  display: grid;
  grid-template-rows: 1fr auto;
}

.section-5-p-white-span-1 {
  display: block;
}

.section-5-p-white-span-2 {
  display: inline-block;
  background-color: #26374C;
  border-radius: 20px;
  color: white;
  padding: 5px 10px;
  width: fit-content;
}

.section-5-p-yellow {
  background-color: #FFE8AE !important;
}


/* section 5 end */

/* section 6 start */

#section-6 {
  font-family: 'Basier Circle';
  margin-top: 65px;
  margin-bottom: 65px;
}

.section-6-title {
  font-size: 60px;
  font-weight: 500;
  color: #567394;
}

.card-image-container {
  position: relative;
  color: white;
  background-color: #567394;
  border-radius: 20px;
  height: 100%;
  padding: 30px;
  min-height: 300px;
}

.section-6-card-title {
  font-size: 35px;
}

.section-6-card-text {
  font-size: 21px;
}

.card-image-container span {
  position: absolute;
  right: 5%;
  top: 10%;
  font-size: 40px;
  font-weight: 500;
  cursor: pointer;
}

.section-6-grid {
  display: grid;
  /*height: 100%;*/
  /* grid-template-rows: 30% auto; */
}

/* section 6 end  */
/* section 7 start */

#section-7 {
  color: #567394;
  font-family: 'Basier Circle';
  margin-bottom: 60px;
}

.section-7-title {
  font-size: 55px;
  font-weight: 500;
  margin: 0
}

.section-7-text {
  font-weight: 500;
  font-size: 25px;
}

.section-7-list-item {
  border-radius: 20px;
  border: 1px solid #567393;
  padding: 16px;
  font-size: 17px;
  font-family: var(--mm-font-gt-america-mono);
}

.section-7-img {
  width: 100%;
}

/* section 7 end */

/* section 8 start */

#section-8 {
  color: white;
  font-family: 'Basier Circle';
  margin-bottom: 75px;
}

.section-8-card-blue-container {
  background-color: #567393;
  border-radius: 20px;
  padding-top: 60px;
  padding-bottom: 60px
}

.section-8-app-image {
  width: 100%;
}

.section-8-title {
  font-size: 55px;
  font-weight: 500;
  line-height: 55px;
}

.section-8-title span {
  color: #FFE8AE;
}

.section-8-text {
  color: white;
}

.section-8-text-yellow {
  color: #FFE8AE;
}

.badges-container {
  display: flex;
  gap: 20px;
  /* flex-direction: row; */
  flex-wrap: wrap;
  /* align-content: center; */
  /* justify-content: flex-start; */
  align-items: center;
}

.badges-container span {
  padding: 10px 20px;
  border-radius: 20px;
  background-color: #FFFFFF;
  color: #567393;
  font-weight: 500;
}

.badges-container img {
  height: 40px;
  width: auto;
}

/* section 8 end */

/* section 9 start */
#section-9 {
  background-color: #FFE8AE;
  color: #567394;
  font-family: 'Basier Circle';
  padding-top: 75px;
  padding-bottom: 30px;
}

#section-9 input, textarea {
  font-size: 20px;
  border-radius: 20px;
  padding: 15px;
  color: #567394;
  border: 0
}

.section-9-title {
  font-size: 60px;
  font-weight: 500;
  line-height: 1;
}

.section-9-text {
  font-size: 21px;
}

#section-9-send-button {
  background-color: #567393;
  color: #FFE8AE;
  border-radius: 10px;
  border-color: #567393;
  font-size: 20px;
}

/* section 9 end */

#start-button {
  border-radius: 20px !important;
  padding: 10px 50px;
  font-size: 17px;
}

#sound-button {
  height: 32px;
  width: 32px;
  margin-top: 15px;
  margin-right: 20px;
  border-radius: 100% !important;
  background-size: 100%;
  background-position: center;
  background-repeat: no-repeat;
}

#sound-button.muted {
  background-image: url("@/assets/landingpage/mute.png");
}

#sound-button.unmuted {
  background-image: url("@/assets/landingpage/volumen.png");
}

#my-player {
  width: 100% !important;
  height: 100vh;
  object-fit: cover;
}

#my-player-mobile {
  width: 100% !important;
  width: 100% !important;
  height: 100vh;
  object-fit: cover;
}

/* Big logo section -----*/
#big-logo-section {
  width: 100%;
  height: auto;
  padding: 50px 0;
}

#big-logo-section img {
  width: 180px;
}

/* Media Queries----- */

@media (min-width: 0px) and (max-width: 576px) {

  #sound-button {
    height: 20px;
    width: 20px;
    margin-top: 0
  }

  #start-button {
    bottom: 6%;
  }

  .landing-container {
    padding: 20px 20px 20px;
  }

  .left-section {
    padding-top: 0;
  }

  .section-2-p-1 {
    font-weight: 500;
    font-size: 16px;
    width: 100%;
  }

  .section-2-p-2 {
    font-size: 16px;
  }

  .yellow-span {
    font-size: 24px;
  }

  .section-2-grid-rows {
    color: white;
    display: grid;
    grid-template-rows: auto 1fr;
    height: 100%;
    gap: 10px;
    margin-top: 1rem;
    width: 80%;

  }

  .section-2-title {
    font-size: 25px;
    font-weight: 500;
    font-family: 'Basier Circle';
    text-align: center;
    margin-bottom: 15px !important;
    /* line-height: 1; */
  }

  .section-2-button a {
    padding: 6px 25px;
    font-size: 12px;
  }

  .section-2-button {
    display: block;
    text-align: center;
    margin-top: 20px;
  }

  .section-2-button button {
    padding: 6px 12px;
    font-size: 15px;
  }

  .section-3-title {
    font-size: 25px;
    font-weight: 500;
  }

  .section-3-text-1 {
    font-size: 16px;
    max-width: 100%;
  }

  .section-3-text-2 {
    font-size: 16px;
  }

  .row-yellow-card-custom-mt {
    margin-top: 3rem !important;
  }

  .yellow-card {
    height: auto;
    margin-bottom: 3rem;
    width: 85%;
    border-radius: 0px;
    padding: 37px 25px 18px;
    max-width: 340px;
  }

  .yellow-card-big-letter {
    font-size: 60px;
  }

  .yellow-card-text-1 {
    font-size: 16px;
  }

  .yellow-card-text-2 {
    font-size: 16px;
  }

  .custom-zero-padding {
    padding: 20px 0px 20px !important;
  }

  .border-top-bottom-right-radius {
    border-top-right-radius: 60px;
    border-bottom-right-radius: 60px;
  }

  .border-top-bottom-left-radius {
    border-top-left-radius: 60px;
    border-bottom-left-radius: 60px;
  }

  .right-items {
    display: flex;
    justify-content: flex-end !important;
  }

  .section-4-title {
    font-size: 25px;
  }

  .section-4-card-blue div {
    width: 50px;
    height: 50px;
    font-size: 30px;
  }

  .m-w-1000 {
    width: auto;
    overflow-x: auto;
    padding-top: 26px;
    white-space: nowrap;
    flex-wrap: nowrap;
    justify-content: normal !important;
  }

  .section-4-card-blue-container {
    white-space: break-spaces;
  }

  .section-4-card-blue {
    padding: 10% 5%;
    min-height: 200px;
    border-radius: 40px;
  }

  .section-4-card-blue p {
    font-size: 20px;
  }

  .section-4-second-blue-card::after {
    display: none;
  }

  .section-4-second-blue-card::before {
    display: none;
  }

  .text-blue.legend {
    font-size: 17px;
  }

  .section-4-card-blue-container {
    width: 260px !important;
    display: inline-block;
    margin: 0 10px 0 0;
  }

  #section-5 {
    background-size: 100%;
    padding-top: 50px;
    padding-bottom: 50px;
  }

  .section-5-title {
    font-size: 25px;
    font-weight: 500;
    margin-bottom: 15px
  }

  /* section 5 start */
  .section-5-p-white {
    height: 100%;
    font-size: 14px;
  }

  .section-5-horizontal-image {
    max-height: 140px;
  }

  .section-5-vertical-image {
    height: 200px;
  }

  /* section 5 end  */
  /* section 6 start */
  .section-6-title {
    font-size: 25px;
  }

  .mb-sm-2 {
    margin-bottom: .5rem !important;
  }

  .section-6-card-title {
    font-size: 22px;
    margin: 0px;
  }

  .section-6-card-text {
    font-size: 16px;
  }

  .card-image-container span {
    font-size: 25px;
  }

  .card-image-container {
    height: auto;
    min-height: auto;
    padding: 20px;
  }

  /* section 6 end */
  /* section 7 start */
  .section-7-title {
    font-size: 25px;
    line-height: 25px;
    margin-bottom: 10px;
  }

  .section-7-text {
    font-size: 18px;
    font-weight: 400;
  }

  .section-7-list-item {
    font-size: 13px;
  }

  /* section 7 end */
  /* section 8 start  */
  .section-8-title {
    font-size: 23px;
    line-height: 23px;
    padding: 0 10px;
  }

  .section-8-text[data-v-4d6f7bf0] {
    font-size: 18px;
    padding: 0 10px;
  }

  .badges-container {
    padding: 0 10px;
  }

  .badges-container span {
    font-size: 13px;
  }

  .section-8-app-image {
    position: absolute;
    top: 0;
    left: 0;
    transform: translateY(-50%);
  }

  .pt-10 {
    padding-top: 10rem !important;
  }

  .mt-6 {
    margin-top: 6rem !important;
  }

  /* section 8 end  */
  /* section 9 start */
  .section-9-title {
    font-size: 25px;
  }

  .section-9-text {
    font-size: 20px;
  }

  #section-9 input, textarea {
    font-size: 16px;
    padding: 10px;
  }

  #section-9-send-button {
    font-size: 16px;
  }

  /* section 9 end */
  .bottom-buttons-video {
    margin-top: -25%;
  }

  #start-button {
    padding: 6px 25px;
    font-size: 12px;
  }

  #section-2 {
    padding-top: 40px;
    padding-bottom: 40px;
  }

  #section-3 {
    padding: 40px 0 0px 0;
  }

  #section-3 .container {
    padding: 0;
  }

  .section-4-card-blue {
    height: 270px;
  }

  .section-4-card-blue p {
    margin: 0 15px;
  }

  .section-4-first-blue-card:before {
    display: none;
  }

  #section-4 {
    padding: 0;
  }

  #section-4 .squares-info {
    margin: 0px 0px;
    padding: 25px
  }

  #section-4 .text-blue.legend {
    padding: 0 15px;
  }

  #section-6 {
    margin-top: 25px;
    margin-bottom: 35px;
  }

  .section-6-card-title {
    font-size: 18px;
  }

  #section-8 {
    margin-top: 100px;
    margin-bottom: 40px;
  }

  #section-9 {
    margin-top: 50px;
    margin-bottom: 40px;
    padding-top: 40px
  }

  #big-logo-section {
    padding: 0 0 30px 0;
  }

  #big-logo-section img {
    width: 170px;
  }

}

@media (min-width: 577px) and (max-width: 767px) {

  .landing-container {
    padding: 20px 20px 20px;
  }

  .left-section {
    padding-top: 0;
  }

  .section-2-p-1 {
    font-weight: 500;
    font-size: 16px;
  }

  .section-2-p-2 {
    font-size: 16px;
  }

  .yellow-span {
    font-size: 24px;
  }

  .section-2-grid-rows {
    color: white;
    display: grid;
    grid-template-rows: auto 1fr;
    height: 100%;
    gap: 10px;
    margin-top: 1rem;
    width: 80%;

  }

  .section-2-title {
    font-size: 22px;
    font-weight: 500;
    font-family: 'Basier Circle';
    /* line-height: 1; */
  }

  .section-2-button {
    display: block;
  }

  .section-2-button button {
    padding: 6px 12px;
    font-size: 15px;
  }

  .section-3-title {
    font-size: 25px;
    font-weight: 500;
  }

  .section-3-text-1 {
    font-size: 16px;
    max-width: 100%;
  }

  .section-3-text-2 {
    font-size: 16px;
  }

  .row-yellow-card-custom-mt {
    margin-top: 3rem !important;
  }

  .yellow-card {
    height: auto;
    margin-bottom: 3rem;
    width: 90%;
    border-radius: 0px;
  }

  .yellow-card-big-letter {
    font-size: 60px;
  }

  .yellow-card-text-1 {
    font-size: 18px;
  }

  .yellow-card-text-2 {
    font-size: 18px;
  }

  .yellow-card {
    padding: 8% 10% 2%;
  }

  .custom-zero-padding {
    padding: 20px 0px 20px !important;
  }

  .border-top-bottom-right-radius {
    border-top-right-radius: 40px;
    border-bottom-right-radius: 40px;
  }

  .border-top-bottom-left-radius {
    border-top-left-radius: 40px;
    border-bottom-left-radius: 40px;
  }

  .right-items {
    display: flex;
    justify-content: flex-end !important;
  }

  .section-4-title {
    font-size: 25px;
  }

  .section-4-card-blue div {
    width: 50px;
    height: 50px;
    font-size: 30px;
  }

  .m-w-1000 {
    width: auto;
    overflow-x: auto;
    padding-top: 26px;
    white-space: nowrap;
    flex-wrap: nowrap;
    justify-content: normal !important;
  }

  .section-4-card-blue-container {
    white-space: break-spaces;
  }

  .section-4-card-blue {
    padding: 10% 5%;
    min-height: 200px;
  }

  .section-4-card-blue p {
    font-size: 18px;
  }

  .section-4-second-blue-card::after {
    display: none;
  }

  .section-4-second-blue-card::before {
    display: none;
  }

  .text-blue.legend {
    font-size: 17px;
  }

  .section-4-card-blue-container {
    width: 300px !important;
    display: inline-block;
    margin: 0 10px 0 0;
  }

  /* section 5 start */
  .section-5-p-white {
    height: 100%;
    font-size: 14px;
  }

  .section-5-horizontal-image {
    max-height: 140px;
  }

  .section-5-vertical-image {
    max-height: 140px;
  }

  /* section 5 end  */
  /* section 6 start */
  .section-6-title {
    font-size: 25px;
  }

  .mb-sm-2 {
    margin-bottom: .5rem !important;
  }

  .section-6-card-title {
    font-size: 25px;
  }

  .section-6-card-text {
    font-size: 16px;
  }

  .card-image-container span {
    font-size: 25px;
  }

  .card-image-container {
    height: auto;
    min-height: auto;
  }

  /* section 6 end */
  /* section 7 start */
  .section-7-title {
    font-size: 25px;
  }

  .section-7-text {
    font-size: 20px;
    font-weight: 400;
  }

  /* section 7 end */
  /* section 8 start  */
  .section-8-title {
    font-size: 25px;
  }

  .section-8-app-image {
    position: absolute;
    top: 0;
    left: 0;
    transform: translateY(-50%);
  }

  .pt-10 {
    padding-top: 16rem !important;
  }

  .mt-6 {
    margin-top: 11rem !important;
  }

  /* section 8 end  */
  /* section 9 start */
  .section-9-title {
    font-size: 25px;
  }

  .section-9-text {
    font-size: 20px;
  }

  #section-9 input, textarea {
    font-size: 16px;
    padding: 10px;
  }

  #section-9-send-button {
    font-size: 16px;
  }

  #big-logo-section img {
    width: 170px;
  }

  /* section 9 end */
}

@media (min-width: 768px) and (max-width: 991px) {
  .landing-container {
    padding: 30px 25px 30px;
  }

  /* setcion 2 start */
  .section-2-title {
    font-size: 50px;
  }

  .section-2-p-1 {
    font-size: 24px;
  }

  .section-2-p-2 {
    font-size: 21px;
  }

  .section-2-button button {
    font-size: 20px;
    padding: 12px 20px;
  }

  /* setcion 2 end */
  /* section 3 start */
  .section-3-title {
    font-weight: 500;
    font-size: 42px;
  }

  .section-3-text-1 {
    font-size: 20px;
  }

  .section-3-text-2 {
    font-size: 20px;
  }

  .yellow-card {
    border-radius: 40px;
  }

  .yellow-card-big-letter {
    font-size: 70px;
  }

  .yellow-card-text-1 {
    font-size: 18px;
  }

  .yellow-card-text-2 {
    font-size: 18px;
  }

  /* section 3 end */
  /* section 4 start */
  .section-4-title {
    font-size: 42px;
  }

  .section-4-card-blue div {
    font-size: 35px;
    height: 55px;
    width: 55px;
  }

  .section-4-card-blue {
    border-radius: 40px;
    padding: 10px;
    min-height: 200px;
  }

  .section-4-card-blue p {
    font-size: 18px;
  }

  .text-blue.legend {
    font-size: 18px;
  }

  /* section 4 ends */
  /* section 5 start */
  /* section 5 end */
  /* section 6 start */
  .card-image-container {
    min-height: 180px;
  }

  .section-6-title {
    font-size: 42px;
  }

  .section-6-card-title {
    font-size: 27px;
  }

  .section-6-card-text {
    font-size: 17px;
  }

  .card-image-container span {
    font-size: 27px;
  }

  /* section 6 end */
  /* section 7 start */
  .section-7-title {
    font-size: 42px;
  }

  .section-7-text {
    font-size: 21px;
  }

  .section-7-list-item {
    font-size: 18px;
  }

  .section-7-list-item {
    padding: 10px;
    font-size: 16px;
  }

  /* section 7 end */
  /* section 8 start */
  .section-8-title {
    font-size: 40px;
  }

  .section-8-text {
    font-size: 20px;
  }

  .badges-container {
    gap: 10px;
  }

  .badges-container span {
    padding: 5px 10px;
  }

  .badges-container img {
    height: 40px;
  }

  .section-8-app-image {
    position: absolute;
    top: 0;
    left: 0;
    transform: translate(15%, -50%);
    width: 80%;
  }

  .pt-10 {
    padding-top: 16rem !important;
  }

  .mt-6 {
    margin-top: 11rem !important;
  }

  /* section 8 end */
  /* section 9 start */
  .section-9-title {
    font-size: 42px;
  }

  .section-9-text {
    font-size: 20px;
  }

  #section-9 input, textarea {
    font-size: 17px;
  }

  #section-9-send-button {
    font-size: 17px;
  }

  #section-9 input {
    padding: 6px;
  }
}

@media (min-width: 992px) and (max-width: 1199px) {
  .landing-container {
    padding: 30px 25px 30px;
  }

  /* setcion 2 start */
  .section-2-title {
    font-size: 50px;
  }

  .section-2-p-1 {
    font-size: 24px;
  }

  .section-2-p-2 {
    font-size: 21px;
  }

  .section-2-button button {
    font-size: 20px;
    padding: 12px 20px;
  }

  /* setcion 2 end */
  /* section 3 start */
  .section-3-title {
    font-weight: 500;
    font-size: 45px;
  }

  .section-3-text-1 {
    font-size: 22px;
  }

  .section-3-text-2 {
    font-size: 22px;
  }

  .yellow-card {
    border-radius: 40px;
  }

  .yellow-card-big-letter {
    font-size: 90px;
  }

  .yellow-card-text-1 {
    font-size: 20px;
  }

  .yellow-card-text-2 {
    font-size: 20px;
  }

  /* section 3 end */
  /* section 4 start */
  .section-4-title {
    font-size: 45px;
  }

  .section-4-card-blue div {
    font-size: 40px;
    height: 60px;
    width: 60px;
  }

  .section-4-card-blue {
    border-radius: 40px;
    padding: 10px;
    min-height: 242px;
  }

  .section-4-card-blue p {
    font-size: 20px;
  }

  .text-blue.legend {
    font-size: 21px;
  }

  /* section 4 ends */
  /* section 5 start */
  /* section 5 end */
  /* section 6 start */
  .card-image-container {
    min-height: 180px;
  }

  .section-6-title {
    font-size: 45px;
  }

  .section-6-card-title {
    font-size: 30px;
  }

  .section-6-card-text {
    font-size: 17px;
  }

  .card-image-container span {
    font-size: 40px;
  }

  /* section 6 end */
  /* section 7 start */
  .section-7-title {
    font-size: 45px;
  }

  .section-7-text {
    font-size: 23px;
  }

  .section-7-list-item {
    font-size: 18px;
  }

  .section-7-list-item {
    padding: 10px;
    font-size: 17px;
  }

  /* section 7 end */
  /* section 8 start */
  .section-8-title {
    font-size: 40px;
  }

  .section-8-text {
    font-size: 20px;
  }

  .badges-container {
    gap: 10px;
  }

  .badges-container span {
    padding: 5px 10px;
  }

  .badges-container img {
    height: 40px;
  }

  /* section 8 end */
  /* section 9 start */
  .section-9-title {
    font-size: 45px;
  }

  .section-9-text {
    font-size: 20px;
  }

  #section-9 input, textarea {
    font-size: 17px;
  }

  #section-9-send-button {
    font-size: 17px;
  }
}

@media (min-width: 1200px) and (max-width: 1679px) {

  /* setcion 2 start */
  .section-2-title {
    font-size: 50px;
  }

  .section-2-p-1 {
    font-size: 24px;
  }

  .section-2-p-2 {
    font-size: 21px;
  }

  .section-2-button button {
    font-size: 20px;
    padding: 12px 20px;
  }

  /* setcion 2 end */
  /* section 3 start */
  .section-3-title {
    font-weight: 500;
    font-size: 50px;
  }

  .section-3-text-1 {
    font-size: 24px;
  }

  .section-3-text-2 {
    font-size: 24px;
  }

  .yellow-card {
    border-radius: 40px;
  }

  .yellow-card-big-letter {
    font-size: 100px;
  }

  .yellow-card-text-1 {
    font-size: 21px;
  }

  .yellow-card-text-2 {
    font-size: 21px;
  }

  /* section 3 end */
  /* section 4 start */
  .section-4-title {
    font-size: 50px;
  }

  .section-4-card-blue div {
    font-size: 50px;
    height: 60px;
    width: 60px;
  }

  .section-4-card-blue {
    border-radius: 40px;
    padding: 10px;
    min-height: 242px;
  }

  .text-blue.legend {
    font-size: 23px;
  }

  /* section 4 ends */
  /* section 5 start */
  /* section 5 end */
  /* section 6 start */
  .section-6-title {
    font-size: 50px;
  }

  .section-6-card-title {
    font-size: 30px;
  }

  .section-6-card-text {
    font-size: 17px;
  }

  .card-image-container span {
    font-size: 40px;
  }

  /* section 6 end */
  /* section 7 start */
  .section-7-title {
    font-size: 50px;
  }

  .section-7-text {
    font-size: 23px;
  }

  .section-7-list-item {
    font-size: 18px;
  }

  /* section 7 end */
  /* section 8 start */
  .section-8-title {
    font-size: 50px;
  }

  .section-8-text {
    font-size: 20px;
  }

  /* section 8 end */
  /* section 9 start */
  .section-9-title {
    font-size: 50px;
  }

  .section-9-text {
    font-size: 24px;
  }

  #section-9 input, textarea {
    font-size: 18px;
  }


}

@media (min-width: 1680px) {


  .section-2-columns-photo-left {
    grid-template-columns: 330px 1fr;
    height: 330px;
  }

  .section-2-columns-photo-right {
    grid-template-columns: 1fr 330px;
    height: 330px;
  }

  .section-5-grid-1-column-2-rows {
    height: 330px;
  }

  .square-grid-photo {
    width: 330px;
    height: 330px;
  }

  .section-5-horizontal-image {
    height: 157.5px;
    -o-object-fit: cover;
    object-fit: cover;
    object-position: 0px 55%;
  }

  .section-5-p-white {
    height: 157.5px;
  }

  .section-5-vertical-image[data-v-4d6f7bf0] {
    max-height: 330px;
  }

}

</style>
